<div class="form-group">
  <label [attr.for]="formControlName" class="control-label  {{isRequired()?'required':''}}">{{ label }}</label>
  <div class="input-group flex-nowrap">
    <textarea  pattern="[a-zA-Z0-9]+" class="form-control" id="exampleFormControlTextarea1" [rows]=numberLines [id]="formControlName"
      [formControl]="control" style="resize: none;" [readonly]="isReadOnly" ></textarea>
  </div>
  <form-field-error [form-control]="control"></form-field-error>
</div>
